import styled from "styled-components";

const ContainerSection = styled.div`
	background-color: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 6px;
	margin: 0 0 2rem 0;
`;

export const Container = styled(ContainerSection)`
	@media (max-width: 426px) {
		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;

export const ContainerBodyHistory = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	max-height: 280px;
	overflow: auto;
`;

export const TableIcons = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 15px;
`;
